<template>
  <div id="toast-wrapper" class="fixed z-50">
    <TheToast to="#toast-wrapper" />
  </div>

  <ErrorBoundary :owners="['bot-squad-content-front']">
    <CookiesModal />
  </ErrorBoundary>

  <ClientOnly>
    <ErrorBoundary :owners="['bot-squad-lifecycle-front']">
      <LeadCollectionPopup v-if="canAttachLeadCollection" />
    </ErrorBoundary>
  </ClientOnly>

  <slot name="header">
    <ErrorBoundary :owners="['bot-squad-search-and-recommendation-front']">
      <Transition enter-from-class="opacity-0" leave-to-class="opacity-0">
        <RevBackdrop
          v-if="isMenuActive || isSearchBarActive"
          class="z-10 hidden backdrop-blur-2xl transition-opacity duration-200 md:block"
        />
      </Transition>

      <TheHeader />
    </ErrorBoundary>
  </slot>

  <slot />

  <slot name="footer">
    <ErrorBoundary :owners="['bot-squad-search-and-recommendation-front']">
      <Footer />
    </ErrorBoundary>
  </slot>
</template>

<script lang="ts" setup>
import { useHead } from '#imports'

import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import ErrorBoundary from '@backmarket/nuxt-module-logger/components/ErrorBoundary.vue'
import TheToast from '@backmarket/nuxt-module-toast/TheToast.vue'
import CookiesModal from '@backmarket/nuxt-module-tracking/CookiesModal.vue'
import { RevBackdrop } from '@ds/components/Backdrop'

import Footer from '~/scopes/navigation/components/Footer/Footer.vue'
import TheHeader from '~/scopes/navigation/components/TheHeader/TheHeader.vue'
import { useNavigation } from '~/scopes/navigation/composables/useNavigation'
import { useToggleSearchBar } from '~/scopes/search-bar/composables/useToggleSearchBar'

import { useAppsflyer } from '../scopes/appsflyer/composables/useAppsflyer'
import LeadCollectionPopup from '../scopes/lead-collection/LeadCollectionPopup.vue'
import { useLeadCollectionPopup } from '../scopes/lead-collection/composables/useLeadCollectionPopup'

const { isMenuActive } = useNavigation()
const { isSearchBarActive } = useToggleSearchBar()
const { canAttachLeadCollection } = useLeadCollectionPopup()

useHead({
  htmlAttrs: {
    lang: useI18nLocale(),
  },
})
useAppsflyer()
</script>

<style>
/* Safari adds an Apple Smart Banner automatically because of the Universal links (See Doorman config: https://github.com/BackMarket/doorman/tree/77be9c7f8e2af4d0f0fc9fe1678ec8f39ac41c69/static/apple/universal-links)
   We want to hide it because we have our own custom Banner with Appsflyer
*/
[class*='apple-banner'] {
  display: none !important;
}
</style>
